import React, { useCallback, useEffect, useState } from 'react';
import { toast } from 'react-toastify';

import { Grid } from '@mui/material';
import { Button, CustomAutocomplete, DatePicker } from 'components';
import { Field, Form, Formik } from 'formik';
import { downloadcsv } from 'helpers/downloadcsv';
import { PageTitle } from 'pages/Layout/PageTitle';
import { providerService } from 'services';

export const BorByPn = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [isListPN, setIsListPN] = useState([{ label: '', value: '' }]);

  const handleList = useCallback(async () => {
    try {
      const { data } = await providerService.getListPN();
      const allPN = [{ label: 'TODOS', value: 'todos' }, ...data];
      console.log(allPN);
      setIsListPN(allPN);
    } catch (error) {
      toast.error(error?.response?.data?.message);
    }
  }, []);

  useEffect(() => {
    handleList();
  }, [handleList]);

  const handleSubmit = async (values) => {
    setIsLoading(true);
    try {
      const { data } = await providerService.getBorByPn({
        list_pn: values.list_pn,
        input_data: values.input_data,
        output_data: values.output_data,
      });
      if (data.length > 0) {
        downloadcsv('ingenico_BOR_por_PN', data);
        toast.success('Relatório gerado com sucesso');
      } else {
        toast.error('Não há dados para esse relatório.');
      }
    } catch (error) {
      toast.error(error?.response?.data?.message);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <PageTitle>Relatório BOR por PN</PageTitle>
      <Formik
        initialValues={{
          list_pn: '',
          input_data: new Date(),
          output_data: new Date(),
        }}
        onSubmit={handleSubmit}
      >
        <Form>
          <Grid container spacing={2}>
            <Grid item xs={12} lg={2}>
              <Field
                size='small'
                disabled={isLoading}
                name='input_data'
                variant='inline'
                fullWidth
                inputVariant='outlined'
                label='Data inicial'
                component={DatePicker}
              />
            </Grid>
            <Grid item xs={12} lg={2}>
              <Field
                size='small'
                disabled={isLoading}
                name='output_data'
                variant='inline'
                fullWidth
                inputVariant='outlined'
                label='Data final'
                component={DatePicker}
              />
            </Grid>
            <Grid item xs={12} md={3} lg={3}>
              <Field
                loading={isLoading}
                name='list_pn'
                label='PN'
                filteredValues={isListPN}
                component={CustomAutocomplete}
              />
            </Grid>
            <Grid item xs={12} md={3} lg={3}>
              <Button fullWidth type='submit' loading={isLoading}>
                Exportar
              </Button>
            </Grid>
          </Grid>
        </Form>
      </Formik>
    </>
  );
};
